import React from 'react'
import { Link } from 'react-router-dom'
import { Tooltip, TooltipProps } from 'antd'
import buttonStyle from '@sass/common/button.module.sass'
import iconStyle from '@sass/common/icon.module.sass'
import c from 'classnames'
import style from './index.module.sass'

interface IProps {
	iconClass?: typeof iconStyle[keyof typeof iconStyle];
	antIcon?: React.ReactNode;
	small?: boolean;
	noHover?: boolean;
	to?: string;
	text?: string;
	onClick?: () => any;

	title?: string;
	description?: React.ReactNode;
	tooltipDirection?: TooltipProps['placement'];

}

export default (props: IProps) => {
	const button = (
		<div
			className={c(style.simpleIcon, buttonStyle.noOutline, {
				[style.smallIcon]: props.small,
				[style.noHover]: props.noHover,
				[props.iconClass || '']: !props.antIcon
			})}
			onClick={props.onClick}
		>
			{props.antIcon || props.text}
		</div>
	)

	return ( 
		<div className={style.simpleIconButton}>
			<Tooltip placement={props.tooltipDirection || "bottom"} title={props.title} >
				{props.to 
					? <Link to={props.to}>
						{button}
					</Link>
					: button
				}
			</Tooltip>
		</div>
	)
}
